import { Box, Heading, Table, TableContainer, Tbody, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { FAST_TRANSFER_MANAGER_STRINGS } from '@views/FastTransferManager/constant';
import React from 'react';
import { FastTransferRow } from '@components/FastTransferManager/FastTransferRow';

export const FastTransferTable = ({
  configs,
  configToEdit,
  formData,
  hasWriteAccess,
  handleToggleChange,
  handleEditMode,
  handleEditCleanUp,
  onConfirmUpdateModalOpen,
  getRowStyles,
}) => {
  if (!configs?.length) {
    return (
      <Box p={4}>
        <Text>{FAST_TRANSFER_MANAGER_STRINGS.NO_CONFIG_FOUND}</Text>
      </Box>
    );
  }

  return (
    <Box>
      <Heading fontSize="lg" mb={4}>
        {FAST_TRANSFER_MANAGER_STRINGS.TABLE_HEADING}
      </Heading>

      <TableContainer border="2px solid" borderRadius="xl">
        <Table variant="unstyled">
          <Thead>
            <Tr>
              {configs[0]?.data.map((field, index) => (
                <Th key={`${field.name}-${index}`} textAlign="center">
                  <Text fontSize="xs">{field.title}</Text>
                </Th>
              ))}
            </Tr>
          </Thead>

          <Tbody>
            {configs.map((configEntity) => (
              <FastTransferRow
                key={configEntity.id}
                configEntity={configEntity}
                configToEdit={configToEdit}
                formData={formData}
                hasWriteAccess={hasWriteAccess}
                handleToggleChange={handleToggleChange}
                handleEditMode={handleEditMode}
                handleEditCleanUp={handleEditCleanUp}
                onConfirmUpdateModalOpen={onConfirmUpdateModalOpen}
                getRowStyles={getRowStyles}
              />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
